import { FreedataValueVO } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import {
  IWizItemRenderer,
  WizTree,
  WizButton,
  TreeItemWrapper,
  WizDatasource,
  WizEventManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';

/**
 * Actions de l'arbre des Freedata values
 */
@Component({
  selector: 'fdvalue-tree-renderer',
  templateUrl: './fdvalue-tree.renderer.html',
})
export class FreedataValueTreeRenderer implements IWizItemRenderer<TreeItemWrapper<FreedataValueVO>, FreedataValueVO> {
  @HostBinding('style.width') elwidth: string = '100%';

  /**
   * renderer back pour deprecated / deleted
   */
  public deprecated() {
    return this.data && this.data.deprecated;
  }
  public deleted() {
    return this.data && this.data.deleted;
  }

  /**
   * return le libellé traduit s'il existe, sinon une chaine vide
   * @returns le label traduit du freedata value
   */
  public getLabel(): string {
    let result: string = this.data.shortCode;
    if (!!this.data.trsLabel) {
      result = '(' + result + ') ' + this.data.trsLabel;
    }
    return result;
  }

  @ViewChild('addButton', { read: WizButton }) addButton: WizButton;
  @ViewChild('deleteButton', { read: WizButton }) deleteButton: WizButton;

  // donneés rempli par le composant wiz-tree
  data: FreedataValueVO;
  owner: WizTree<FreedataValueVO>;
  context: TreeItemWrapper<FreedataValueVO>;

  constructor(public elementRef: ElementRef) {}

  /** delete autorisé ? */
  public canAdd(): boolean {
    let result: boolean = true;
    if (this.data.getParentFDVO().kindWild) {
      result = false;
    }
    if (this.data.getParentFDVO().kindMeasure) {
      result = false;
    }
    return result;
  }

  /** delete autorisé ? */
  public canDelete(): boolean {  
    return !this.data.isUsed;
  }

  /** demande d'ajout */
  public doAdd(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.ADD, this.data, this));
  }

  /** demande de suppression */
  public doDelete(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.DELETE, this.data, this));
  }

  /**
   * inversion de la couleur des boutons d'action
   * @returns boolean, true si la ligne est sélectionné, false sinon
   */
  public isSelected(): boolean {
    const datas: WizDatasource<any> = this.owner.wizDataProvider;
    if (datas && datas.selectedItems && datas.selectedItems.indexOf(this.data) > -1) {
      return true;
    }
    return false;
  }
}
